export const base64ToArrayBuffer = (base64) => {
  const binaryString = window.atob(base64)
  const bytes = new Uint8Array(binaryString.length)
  return bytes.map((byte, i) => binaryString.charCodeAt(i))
}

export const createAndDownloadBlobFile = (body, fileName) => {
  const blob = new Blob([body])
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, fileName)
  } else {
    const link = document.createElement('a')
    // Browsers that support HTML5 download attribute
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', fileName)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

export const getExtension = fileName => /[^.]+$/.exec(fileName).pop()

export default { base64ToArrayBuffer, createAndDownloadBlobFile, getExtension }



// WEBPACK FOOTER //
// ./src/services/downloadService.js